<template>
    <Layout>
        <app-head :noindex="true" title="Privacy Policy"/>

        <div class="col-lg-7 col-10 mx-auto" id="privacy-policy">

            <div class="px-6 pt-5 mt-2 mt-lg-5">
                <h3 class="display-5 mb-4 mb-lg-2 fw-bold text-center">
                    Privacy Policy
                </h3>
            </div>

            <legal-block title="">
                <template v-slot:extra>
                    Private Gym B.V. respecteert de privacy van de bezoekers van de Website en de gebruikers van de
                    App, in het bijzonder de rechten van bezoekers met betrekking tot de geautomatiseerde verwerking
                    van persoonsgegevens. Vanwege volledige transparantie met onze klanten hebben wij daarom een beleid
                    geformuleerd en geïmplementeerd met betrekking tot deze verwerkingen zelf, het doel ervan alsook de
                    mogelijkheden voor betrokkenen om hun de rechten zo goed mogelijk te kunnen uitoefenen.<br/><br/>

                    Deze privacyverklaring geldt zowel voor de website privategym.nl als voor de mobiele applicatie
                    “Private Gym Clients” voor iOS en Android (hierna “de App”). Waar hieronder “de Website” staat,
                    wordt daarmee ook de App bedoeld, tenzij uitdrukkelijk anders vermeld.<br/><br/>

                    Voor alle aanvullende informatie over de bescherming van persoonsgegevens kunt u terecht op de
                    website van de Autoriteit persoonsgegevens:
                    <a href="https://autoriteitpersoonsgegevens.nl/nl">https://autoriteitpersoonsgegevens.nl/nl</a>.<br/><br/>

                    Met het voortzetten van het bezoek van de Website accepteert u de volgende gebruikersvoorwaarden. U
                    accepteert het gebruik van cookies en andere tracking systems. Indien u dit gebruik wenst te
                    weigeren dient u op de volgende link te klikken
                    <a href="https://www.privategym.nl/weiger-cookies">https://www.privategym.nl/weiger-cookies</a>.<br/><br/>

                    De huidige op de Website beschikbare versie van de privacyverklaring is de enige versie die van
                    toepassing is zolang u de Website bezoekt, totdat een nieuwe versie de huidige versie vervangt.
                </template>
            </legal-block>

            <legal-block title="Wettelijke bepalingen">
                <legal-block-entry>
                    <template v-slot:number>
                        1
                    </template>
                    <template v-slot:content>
                        Website (hierna ook “de website”): Private Gym
                    </template>
                </legal-block-entry>
                <legal-block-entry>
                    <template v-slot:number>
                        2
                    </template>
                    <template v-slot:content>
                        Verantwoordelijke voor de verwerking van persoonsgegevens (Hierna ook: “De beheerder”): Private
                        Gym B.V., gevestigd te Smedenstraat 286, 7411RD Deventer, kvk-nummer: 83068791.
                    </template>
                </legal-block-entry>

            </legal-block>

            <legal-block title="Toegang tot de website">
                <template v-slot:extra>
                    De toegang tot de website en het gebruik is strikt persoonlijk. U zult deze website alsook de
                    gegevens en informatie die daarop verstrekt worden niet gebruiken voor commerciële, politieke of
                    publicitaire doeleinden, dan wel voor enige commerciële aanbiedingen en in het bijzonder niet
                    gebruiken voor ongevraagde elektronische aanbiedingen.
                </template>
            </legal-block>

            <legal-block title="De content van de website  ">
                <template v-slot:extra>
                    Alle merken, afbeeldingen, teksten, commentaren, illustraties, (animatie)plaatjes, videobeelden,
                    geluiden, alsook alle technische applicaties die gebruikt kunnen worden om de website te laten
                    functioneren en meer in het algemeen alle onderdelen die op deze site zijn gebruikt, zijn beschermd
                    bij wet door intellectuele eigendomsrechten. Iedere reproductie, herhaling, gebruik of aanpassing,
                    op welke wijze dan ook, van het geheel of slechts een onderdeel ervan, met inbegrip van de
                    technische applicaties, zonder voorafgaande schriftelijke toestemming van de verantwoordelijke, is
                    ten strengste verboden. Indien de beheerder niet meteen actie onderneemt tegen enig inbreuk, kan dat
                    niet worden opgevat als stilzwijgende toestemming dan wel het afzien van rechtsvervolging.
                </template>
            </legal-block>

            <legal-block title="Het beheer van de website">
                <template v-slot:extra>
                    Voor het goede beheer van de website kan de beheerder op ieder moment:
                    <ul class="mt-2">

                        <li> de toegang aan een bepaalde categorie bezoekers schorsen, onderbreken of beperken tot de
                            gehele of een gedeelte van de website
                        </li>
                        <li> alle informatie verwijderen die het functioneren van de website kan verstoren of in strijd
                            is met nationale of internationale wetgeving of in strijd is met internet-etiquette
                        </li>
                        <li> de website tijdelijk niet beschikbaar hebben teneinde updates uit te kunnen voeren</li>
                    </ul>
                </template>
            </legal-block>

            <legal-block title="Verantwoordelijkheden">
                <template v-slot:extra>
                    De beheerder is niet aansprakelijk voor juridische procedures die tegen u worden gevoerd:
                    <ul class="mt-2">
                        <li>
                            vanwege het gebruik van de website of diensten toegankelijk via internet
                        </li>
                        <li>
                            vanwege het schenden van de voorwaarden van deze privacy policy
                        </li>
                    </ul>
                    De beheerder is niet verantwoordelijk voor enige schade die u zelf oploopt, dan wel derden of uw
                    apparatuur oplopen als gevolg van uw verbinding met of het gebruik van de website. U zult zich
                    onthouden van iedere actie tegen de beheerder als gevolg hiervan.

                    Indien de beheerder betrokken raakt bij een geschil als gevolg van uw gebruik van deze website, is
                    hij gerechtigd alle schade die hij dientengevolge lijdt en nog zal lijden op u te verhalen.
                </template>
            </legal-block>

            <legal-block title="Het verzamelen van gegevens">
                <template v-slot:extra>
                    Uw gegevens worden verzameld door Private Gym B.V. en (een) externe verwerker(s). Onder
                    persoonsgegevens worden verstaan: alle informatie over een geïdentificeerde of identificeerbare
                    natuurlijke persoon; als identificeerbaar wordt beschouwd een natuurlijke persoon die direct of
                    indirect kan worden geïdentificeerd, met name aan de hand van een identificator zoals een naam, een
                    identificatienummer, locatiegegevens, een online identificator of een of meer elementen die
                    kenmerkend zijn voor de fysieke, fysiologische, genetische, psychische, economische, culturele of
                    sociale identiteit.

                    De persoonsgegevens die op de website worden verzameld worden hoofdzakelijk gebruikt door de
                    beheerder voor het onderhouden van relaties met u en indien aan de orde voor het verwerken van uw
                    bestellingen.
                </template>
            </legal-block>

            <legal-block title="De App">
                <template v-slot:extra>
                    De App is bedoeld voor leden van Private Gym en geeft toegang tot het reserveren van een eiland,
                    het openen van de deur van de sportschool, het inzien van uw abonnement en betalingen, en
                    mededelingen van Private Gym. Om die functies te kunnen leveren verwerken wij in de App de gegevens
                    van uw ledenaccount, uw reserveringen en deurgebeurtenissen, uw abonnements- en betaalstatus, en
                    technische gegevens die nodig zijn om de App te laten werken.<br/><br/>

                    De App verzamelt geen locatiegegevens, geen contacten, geen agenda, geen foto's en geen
                    gezondheids- of biometrische gegevens. De App bevat geen advertenties en volgt u niet over andere
                    apps of websites heen. Wij verkopen uw gegevens niet en gebruiken ze niet voor advertentiedoeleinden.
                </template>
            </legal-block>

            <legal-block title="Pushmeldingen">
                <template v-slot:extra>
                    Als u daarvoor toestemming geeft, stuurt de App u pushmeldingen. Wij gebruiken pushmeldingen voor de
                    volgende doeleinden:
                    <ul class="mt-2">
                        <li>herinneringen aan een reservering en het bevestigen of vrijgeven daarvan;</li>
                        <li>meldingen over uw abonnement of een betaling die aandacht nodig heeft;</li>
                        <li>operationele mededelingen over de sportschool, bijvoorbeeld bij storing of gewijzigde
                            openingstijden;
                        </li>
                        <li>nieuwsberichten van Private Gym, uitsluitend wanneer u die categorie zelf heeft
                            aangezet.
                        </li>
                    </ul>

                    <strong>Welke gegevens hiervoor worden verwerkt.</strong> Om een pushmelding op uw toestel te kunnen
                    afleveren, slaan wij een zogenoemd apparaat-token op: een unieke, door Apple of Google uitgegeven
                    identificator van de installatie van de App op uw toestel. Bij dat token bewaren wij het
                    platform (iOS of Android), de versie van de App en het moment waarop het token voor het laatst is
                    gebruikt. Wij koppelen het token aan uw ledenaccount, zodat een melding die voor u bestemd is op al
                    uw eigen toestellen aankomt en niet op dat van iemand anders. Een apparaat-token is geen
                    advertentie-identificator en wordt door ons niet voor advertenties of profilering gebruikt.<br/><br/>

                    <strong>Apple en Google als verwerkers.</strong> Een pushmelding kan uw toestel technisch alleen
                    bereiken via de push-infrastructuur van de fabrikant van uw besturingssysteem. Wij schakelen
                    daarvoor de volgende verwerkers in:
                    <ul class="mt-2">
                        <li><strong>Apple Inc.</strong> — Apple Push Notification service (APNs), voor toestellen met
                            iOS. Apple ontvangt het apparaat-token en de inhoud van de melding om deze aan uw toestel af
                            te leveren.
                        </li>
                        <li><strong>Google Ireland Limited</strong> (en, voor zover van toepassing, Google LLC) —
                            Firebase Cloud Messaging (FCM), voor toestellen met Android. Google ontvangt het
                            apparaat-token en de inhoud van de melding om deze aan uw toestel af te leveren.
                        </li>
                    </ul>
                    Apple en Google verwerken deze gegevens uitsluitend om de melding af te leveren en om ons terug te
                    melden dat een token niet langer geldig is. Bij deze doorgifte kunnen gegevens worden verwerkt
                    buiten de Europese Economische Ruimte; die doorgifte vindt plaats op basis van de daarvoor geldende
                    waarborgen, waaronder standaardcontractbepalingen van de Europese Commissie en, voor zover van
                    toepassing, het EU-VS Data Privacy Framework.<br/><br/>

                    <strong>Wat er niet in een melding staat.</strong> Wij nemen in de inhoud van een pushmelding nooit
                    bedragen, factuurnummers, betaalgegevens of andere bijzondere of identificerende gegevens op. Een
                    melding verwijst u naar het betreffende scherm in de App; de gegevens zelf ziet u pas nadat u bent
                    ingelogd.<br/><br/>

                    <strong>Grondslag.</strong> Meldingen over uw reserveringen, uw abonnement en de werking van de
                    sportschool sturen wij op grond van de uitvoering van de overeenkomst met u. Nieuws- en
                    marketingberichten sturen wij uitsluitend op grond van uw toestemming; die categorie staat standaard
                    uit.<br/><br/>

                    <strong>Uw controle.</strong> U kunt pushmeldingen op ieder moment volledig uitzetten in de
                    instellingen van uw besturingssysteem, en u kunt de afzonderlijke categorieën aan- en uitzetten in
                    de instellingen van de App. Het uitzetten van meldingen heeft geen gevolgen voor uw lidmaatschap;
                    e-mail blijft in dat geval het middel waarmee wij u bereiken waar dat noodzakelijk is.<br/><br/>

                    <strong>Bewaartermijn.</strong> Wij verwijderen het apparaat-token zodra u op dat toestel uitlogt,
                    zodra Apple of Google ons meldt dat het token niet langer geldig is, en in ieder geval wanneer uw
                    account wordt verwijderd. Zolang u ingelogd blijft, blijft het token bewaard omdat het anders niet
                    mogelijk is u een melding te sturen.
                </template>
            </legal-block>

            <legal-block title="Verwerkers">
                <template v-slot:extra>
                    Wij schakelen voor de Website en de App de volgende categorieën verwerkers in. Met elk van deze
                    partijen is een verwerkersovereenkomst gesloten en zij mogen uw gegevens uitsluitend gebruiken voor
                    de opdracht die wij hun geven.
                    <ul class="mt-2">
                        <li><strong>Apple Inc.</strong> — aflevering van pushmeldingen op iOS (APNs).</li>
                        <li><strong>Google Ireland Limited</strong> — aflevering van pushmeldingen op Android (Firebase
                            Cloud Messaging).
                        </li>
                        <li><strong>Mollie B.V.</strong> — verwerking van betalingen en incasso.</li>
                        <li><strong>Bird / SparkPost</strong> — verzending van transactionele e-mail.</li>
                        <li><strong>Functional Software, Inc. (Sentry)</strong> — foutmeldingen en storingsdiagnose.</li>
                        <li><strong>DigitalOcean, LLC</strong> — hosting van de servers waarop de dienst draait.</li>
                        <li><strong>Pusher Ltd</strong> — het direct bijwerken van uw accountgegevens in de App.</li>
                    </ul>
                    Een actueel en volledig overzicht van onze verwerkers kunt u opvragen via support@privategym.nl.
                </template>
            </legal-block>

            <legal-block title="Uw rechten met betrekking tot uw gegevens">
                <template v-slot:extra>
                    Op grond van artikel 13 lid 2 sub b AVG heeft eenieder recht op inzage van en rectificatie of
                    wissing van zijn persoonsgegevens of beperking van de hem betreffende verwerking, alsmede het recht
                    tegen de verwerking bezwaar te maken en het recht op gegevensoverdraagbaarheid. U kunt deze rechten
                    uitoefenen door contact met ons op te nemen via support@privategym.nl.

                    Ieder verzoek daartoe dient te worden vergezeld van een kopie van een geldig identiteitsbewijs,
                    waarop u uw handtekening heeft gezet en onder vermelding van het adres waarop er met u contact kan
                    worden opgenomen. Binnen 1 maand na het ingediende verzoek, krijgt u antwoord op uw verzoek.
                    Afhankelijk van de complexiteit van de verzoeken en het aantal van de verzoeken kan deze termijn
                    indien nodig met 2 maanden worden verlengd.
                </template>
            </legal-block>

            <legal-block title="Verwerking van persoonsgegevens">
                <template v-slot:extra>
                    In geval van schending van enige wet- of regelgeving, waarvan de bezoeker wordt verdacht en waarvoor
                    de autoriteiten persoonsgegevens nodig hebben die de beheerder heeft verzameld, worden deze aan hen
                    verstrekt na een uitdrukkelijk en gemotiveerd verzoek van die autoriteiten, waarna deze
                    persoonsgegevens mitsdien niet meer onder de bescherming van de bepalingen van deze
                    privacyverklaring vallen.

                    Indien bepaalde informatie noodzakelijk is om toegang te krijgen tot bepaalde functionaliteiten van
                    de website, zal de verantwoordelijke het verplichte karakter van deze informatie aangeven op het
                    moment van het vragen van de gegevens.
                </template>
            </legal-block>

            <legal-block title="Commerciële aanbiedingen">
                <template v-slot:extra>
                    U kunt commerciële aanbiedingen krijgen van de beheerder. Indien u deze niet (meer) wenst te
                    ontvangen, stuurt u een mail naar het volgende adres: support@privategym.nl.

                    Indien u tijdens het bezoek van de website enige persoonsgegevens tegenkomt, dient u zich te
                    onthouden van het verzamelen ervan of van enig ander ongeoorloofd gebruik alsook van iedere daad die
                    een inbreuk op de persoonlijke levenssfeer van die perso(o)n(en) oplevert. De beheerder is in geen
                    geval verantwoordelijk in bovengenoemde situaties.
                </template>
            </legal-block>

            <legal-block title="Bewaartermijn gegevens">
                <template v-slot:extra>
                    De door de beheerder van website verzamelde gegevens worden gebruikt en bewaard voor de duur zoals
                    deze bij wet is bepaald.
                </template>
            </legal-block>

            <legal-block title="Cookies">
                <template v-slot:extra>
                    <ol>
                        <li>
                            Een cookie is een klein tekstbestand dat bij bezoek aan onze website geplaatst wordt op de
                            harde schijf van uw computer. Een cookie bevat gegevens zodat u bij elk bezoek aan onze
                            website als bezoeker kan worden herkend. Het is dan mogelijk om onze website speciaal op u
                            in te stellen en het inloggen te vergemakkelijken. Wanneer u onze website bezoekt,
                            verschijnt er een banner waarmee we u informeren over het gebruik van cookies. Bij verder
                            gebruik van onze website accepteert u het gebruik ervan. Uw toestemming is geldig voor een
                            periode van dertien maanden.
                        </li>
                        <li>
                            Wij gebruiken de volgende soorten cookies op onze website:
                            <ul class="mt-2">
                                <li>Functionele cookies: zoals sessie- en login cookies voor het bijhouden van sessie-
                                    en inloginformatie.
                                </li>
                                <li>Geanonimiseerde Analytische cookies: om inzage te krijgen in het bezoek aan onze
                                    website op basis van informatie over bezoekersaantallen, populaire pagina’s en
                                    onderwerpen. Op deze wijze kunnen we de communicatie en informatievoorziening beter
                                    afstemmen op de behoeften van bezoekers van onze website. We kunnen niet zien wie
                                    onze websites bezoekt of vanaf welke pc het bezoek plaatsvindt.
                                </li>
                                <li>Niet-geanonimiseerde Analytische cookies: om inzage te krijgen in het bezoek aan
                                    onze website op basis van informatie over bezoekersaantallen, populaire pagina’s en
                                    onderwerpen. Op deze wijze kunnen we de communicatie en informatievoorziening beter
                                    afstemmen op de behoeften van bezoekers van onze website.
                                </li>
                                <li>Tracking cookies: zoals advertentiecookies die zijn bedoeld voor het tonen van
                                    relevante advertenties. Uit de informatie over bezochte websites kunnen persoonlijke
                                    interesses worden afgeleid. Daarmee kunnen organisaties hun websitebezoekers
                                    bijvoorbeeld gerichte advertenties tonen. Tracking cookies maken het mogelijk om
                                    profielen van mensen op te stellen en hen anders te behandelen. Met tracking cookies
                                    worden doorgaans persoonsgegevens verwerkt.
                                </li>
                            </ul>
                        </li>
                        <li>
                            Meer specifiek gebruiken wij de volgende cookies:
                            <ul class="mt-2">
                                <li>Google Analytics geanonimiseerd (analytische cookies)</li>
                                <li>Google Analytics (analytische cookie)</li>
                                <li>Google Adwords (tracking cookie)</li>
                            </ul>
                        </li>
                        <li>
                            Wanneer u onze website bezoekt kunnen cookies afkomstig van de verantwoordelijke en/of
                            derden op uw apparatuur worden geïnstalleerd.
                        </li>
                        <li>
                            Voor meer informatie over het gebruik, het beheer en het verwijderen van cookies voor elk
                            besturingstype, nodigen wij u uit om de volgende link te raadplegen:
                            <a href="https://autoriteitpersoonsgegevens.nl/nl/onderwerpen/internet-telefoon-tv-en-post/cookies#faq">https://autoriteitpersoonsgegevens.nl/nl/onderwerpen/internet-telefoon-tv-en-post/cookies#faq</a>
                        </li>
                    </ol>
                </template>
            </legal-block>

            <legal-block title="Beeldmateriaal en aangeboden producten">
                <template v-slot:extra>
                    Aan het beeldmateriaal dat behoort bij de aangeboden producten op de website kunnen geen rechten
                    worden ontleend.
                </template>
            </legal-block>

            <legal-block title="Toepasselijk recht">
                <template v-slot:extra>
                    Op deze voorwaarden is Nederlands Recht van toepassing. De rechtbank van de vestigingsplaats van de
                    beheerder is exclusief bevoegd bij eventuele geschillen omtrent deze voorwaarden, behoudens wanneer
                    hierop een wettelijke uitzondering van toepassing is.
                </template>
            </legal-block>

            <legal-block title="Contact">
                <template v-slot:extra>
                    Voor vragen, productinformatie of informatie over de website zelf, kunt u zich richten tot:
                    Directie, support@privategym.nl.
                </template>
            </legal-block>

            <legal-block title="Toeschrijving">
                <template v-slot:extra>
                    Deze privacyverklaring is van toepassing sinds 2022-03 tot nader order. Laatst gewijzigd in
                    2026-08, met de toevoeging van de App, pushmeldingen en het overzicht van verwerkers.
                </template>
            </legal-block>


        </div>
        <div class="m-5"></div>

    </Layout>
</template>
<style lang="scss">
    #privacy-policy {
        ol {
            & > li {
                margin-top: 10px;
            }
        }
    }
</style>

<script>
import Layout from '../../Components/Layout'
import AppHead from "../../Components/AppHead";
import LegalBlock from "../../Components/Legal/LegalBlock";
import LegalBlockEntry from "../../Components/Legal/LegalBlockEntry";

export default {
    components: {
        LegalBlockEntry,
        LegalBlock,
        AppHead,
        Layout,
    },
    props: {
        user: Object,
    },
}
</script>
